var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { margin } from '../../utils/margin';
import { useColorSet } from '../ThemeProvider/useColorSet';
import { SuperEllipseBadge } from './SuperEllipseBadge';
import { SuperEllipseIcon } from './SuperEllipseIcon';
import { SuperEllipseSvg } from './SuperEllipseSvg';
import { SuperEllipseText } from './SuperEllipseText';
const StyledSuperEllipse = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 0;
  height: ${(props) => props.size + 'px'};
  width: ${(props) => props.size + 'px'};

  ${margin}
`;
const ChildrenWrapper = styled.div `
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SuperEllipse = (_a) => {
    var { size, withStroke, colorSet, invertedColor, highlight, image, icon, text, badge, strokeColor, children } = _a, props = __rest(_a, ["size", "withStroke", "colorSet", "invertedColor", "highlight", "image", "icon", "text", "badge", "strokeColor", "children"]);
    const colors = useColorSet({
        colorSet,
        invertedColor,
    });
    return (React.createElement(StyledSuperEllipse, Object.assign({ size: size }, props),
        React.createElement(SuperEllipseSvg, { image: !icon ? image : '', backgroundColor: colors.background, withStroke: withStroke || Boolean(strokeColor), strokeColor: strokeColor, highlight: highlight }),
        React.createElement(ChildrenWrapper, null,
            React.createElement(SuperEllipseIcon, { size: size, color: colors.content, icon: icon }),
            React.createElement(SuperEllipseBadge, { size: size, badge: badge }),
            !icon && !image && (React.createElement(SuperEllipseText, { size: size, color: colors.content, text: text })),
            !icon && !image && !text && children)));
};
